module.exports = __webpack_public_path__ + "img/subBanner19.4b39794d.png";